import {CentreReview, Job, Profile} from '../../models';
import {API} from '../types';
import {jobs} from '../mockDB';

type Params = {
  _start: number;
  _limit: number;
  _sort: string;
  centreId: number;
  profileSkillId?: number[];
};

interface Response {
  list: (CentreReview & {profile: Profile; job: Job})[];
  total: number;
}

export function getCentreReviewsAPI(params: Params): API<Response> {
  const urlParams = {
    ...params,
    ...(params.profileSkillId && {
      profileSkillId: params.profileSkillId.join(','),
    }),
  };
  return {
    getData: async client => {
      const {data} = await client({
        url: '/centre-reviews',
        method: 'GET',
        params: urlParams,
      });
      return {data: data};
    },
    getMockData: () => {
      return {
        list: [
          {
            id: 1,
            comments: 'string',
            profileId: 1,
            centreId: 1,
            jobId: 1,
            createdAt: '2021-09-13T10:33:13.901Z',
            profile: {
              id: 1,
              role: 'HR',
              name: 'Name',
              createdAt: '2021-09-13T10:33:13.901Z',
              updatedAt: '2021-09-13T10:33:13.901Z',
            },
            job: jobs[0],
          },
        ],
        total: 0,
      };
    },
  };
}
